import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  accessToken: null,
  fromPageChange: true
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload.accessToken
      state.fromPageChange = action.payload.fromPageChange
    }
  }
})

export const { setAccessToken } = authSlice.actions
export const selectAuth = (state) => state.auth

export default authSlice.reducer
